import type { RouteRecordRaw } from 'vue-router'

export const amenitiesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/amenities',
    name: 'AMENITIES',
    component: () => import('./AmenitiesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
